export const EDITTING_POLICY = 'scenes/VehicleDetail/components/Policy/editting_policy'

export const ADD_EXTRA_DATA = 'scenes/VehicleDetail/components/Policy/add_extra_data'
export const DELETE_EXTRA_DATA_FIELD = 'scenes/VehicleDetail/components/Policy/delete_extra_data_field'
export const UPDATE_EXTRA_DATA_FIELD = 'scenes/VehicleDetail/components/Policy/update_extra_data_field'

export const IMPORT_EXTRA_DATA = 'scenes/VehicleDetail/components/Policy/import_extra_data'



// WEBPACK FOOTER //
// ./src/scenes/VehicleDetail/components/Policy/constants.js